angular.module('cfn').service('companyFinanceService', [
  '$log',
  'enumFilter',
  function($log, enumFilter) {
    'use strict';

    this.getVatRate = function() {
      if (app.credentials && app.credentials.company) {
        return app.credentials.company.vatRate;
      }
      return undefined;
    };

    this.getCurrencyUnit = function() {
      if (app.credentials && app.credentials.company) {
        return app.credentials.company.currencyUnit;
      }
      return undefined;
    };

    /**
     * Sets new vat rate (if updated in application and credentials are not reloaded)
     */
    this.setVatRate = function(newVatRate) {
      if (app.credentials && app.credentials.company) {
        app.credentials.company.vatRate = newVatRate;
      } else {
        $log.error('Cannot update vat rate, credentials not set');
      }
    };

    /**
     * Sets new currency unit (if update in application and credentials are not reloaded)
     */
    this.setCurrencyUnit = function(newCurrencyUnit) {
      if (app.credentials && app.credentials.company) {
        app.credentials.company.currencyUnit = newCurrencyUnit;
      } else {
        $log.error('Cannot update currency unit, credentials not set');
      }
    };

    /**
     * Returns currency as acronym, e.g. "EUR"
     */
    this.getCurrencySymbol = function() {
      return enumFilter(this.getCurrencyUnit(), 'UnitsCurrencyEnum');
    };

    /**
     * Returns currency as sign, e.g. "€"
     */
    this.getCurrencySign = function() {
      return enumFilter(this.getCurrencyUnit(), 'UnitsCurrencySignEnum');
    };
  }
]);
